import {QueryClientProvider} from '@tanstack/react-query';
import {type ReactNode} from 'react';
import {queryClient} from '@lib/query-client';

interface QueryProviderProps {
  children: ReactNode;
}

export const QueryProvider = ({children}: QueryProviderProps) => (
  <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
);
